import { Component, OnInit, OnDestroy, ViewEncapsulation, TemplateRef, ElementRef, ViewChild, HostListener } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { Location, DatePipe } from '@angular/common';
import { FormBuilder, Validators, FormGroup, FormControl } from "@angular/forms";
import { NgbModalRef, NgbModal, NgbCalendar } from "@ng-bootstrap/ng-bootstrap";
import { finalize, takeUntil } from "rxjs/operators";

import { GenericResponse, GenericStatus, Page, IUserAccount, IResource } from "../../../../../shared/models";
import { HttpService, NotifyService, AppData, ResourceService } from "../../../../../shared/services";
import { ApiResources, LinqHelper } from "../../../../../shared/helpers";
import { ActiveStatus, Dates, GlobalAllViewModel, PIXEL_PER_LETTER, BUFFER_WIDTH, AdmissionFetchHelper, USER_BUFFER_WIDTH, SNO_WIDTH, UNIT_WIDTH, TIME_USER_BUFFER_WIDTH } from "../../shared/helper";
import { WhenType, FilterType, ProgressReportMedication, DatesViewModel, ViewType, DateHolder, TimeSlotHelper, MarkDetails, IMoveModel } from "./local.helper";
import { IAdmissionModel } from "../../../services/models/admission.model";
import { Lab, LabStatusType } from "../labs/helpers/helper";
import { HourHolder } from "../../../nurse-module/helpers/helper";

@Component({
    selector: "progress-report-timeline",
    templateUrl: "./timeline.html",
    styleUrls: ["./timeline.css"],
    encapsulation: ViewEncapsulation.None
})
export class ProgressReportTimelinePage implements OnInit, OnDestroy {

    id: number;
    encryptId: string;
    isAdmission: boolean;
    page: Page;
    modalRef: NgbModalRef;
    loading: boolean;
    dates: Dates;
    allDates: Array<Date>;
    whenType = WhenType;
    viewType = ViewType;
    filterType = FilterType;
    activeStatus = ActiveStatus;
    labStatusType = LabStatusType;

    currentViewType: ViewType;
    admission: IAdmissionModel;
    filterForm: FormGroup;
    moveForm: FormGroup;
    productWidth: number;
    userWidth: number;
    unitWidth: number;
    snoWidth: number;
    imgOrigin: string;
    previousLoading: boolean;
    nextLoading: boolean;
    contentLoading: boolean;

    cloneRecords: Array<GlobalAllViewModel<ProgressReportMedication, Lab>>;
    records: Array<GlobalAllViewModel<ProgressReportMedication, Lab>>;

    // Nurse Actions
    showNurses: boolean;
    isAdmissionMode: boolean;
    isNurseMode: boolean;
    dateHolder: DateHolder;
    nurses: Array<IResource>;
    patients: Array<IResource>;

    @ViewChild('scrollDiv', { static: true }) scrollDiv: ElementRef;
    hours: Array<HourHolder>
    markDetails: MarkDetails;
    interval: any;
    setHeight: boolean;
    movingIndex: number;
    movingObjectIndex: number;
    movingObject: TimeSlotHelper;
    moveSubmitted: boolean;
    moveSubmitting: boolean;
    moves: Array<IMoveModel>;

    constructor(
        private readonly httpService: HttpService,
        private readonly modalService: NgbModal,
        private readonly notifyService: NotifyService,
        private readonly appData: AppData,
        private readonly formBuilder: FormBuilder,
        private readonly route: ActivatedRoute,
        private readonly locationService: Location,
        private readonly calendar: NgbCalendar,
        private readonly admissionFetchHelper: AdmissionFetchHelper,
        private readonly resourceService: ResourceService,
        private readonly datePipe: DatePipe
    ) {
        this.page = new Page();
        this.currentViewType = ViewType.Patients;
        this.snoWidth = SNO_WIDTH;
        this.unitWidth = UNIT_WIDTH;

        this.moves = new Array<IMoveModel>();
        this.movingIndex = -1;
        this.movingObjectIndex = -1;

        this.markDetails = new MarkDetails();
        this.setMarkDetails();
        this.interval = setInterval(() => { this.setMarkDetails(); }, 1000 * 60)
        this.nurses = new Array<IResource>();
        this.patients = new Array<IResource>();
        this.isNurseMode = "Nurse" === this.route.snapshot.data['role'];
        this.isAdmissionMode = "Admission" === this.route.snapshot.data['role'];
        this.setDateHolder();

        this.cloneRecords = new Array<GlobalAllViewModel<ProgressReportMedication, Lab>>();
        this.records = new Array<GlobalAllViewModel<ProgressReportMedication, Lab>>();
        this.imgOrigin = location.origin + location.pathname;
        this.dates = new Dates();
        this.dates.current = new Date();
        this.dates.min = new Date(new Date().setDate(new Date().getDate() - 1));
        this.dates.max = new Date(new Date().setDate(new Date().getDate() + 1));
        this.allDates = new Array<Date>();

        this.hours = Array.from(Array(24)).map((_x, i) => {
            let hour = 1 + i;
            var icon = i >= 4 && i <= 10
                ? 'weather-sunset-up'
                : i > 10 && i <= 15
                    ? 'white-balance-sunny'
                    : i > 15 && i <= 19
                        ? 'weather-sunset-down'
                        : 'weather-night';
            var name = i >= 4 && i <= 10
                ? 'Morning'
                : i > 10 && i <= 15
                    ? 'Afternoon'
                    : i > 15 && i <= 19
                        ? 'Evening'
                        : 'Night';
            var isAm = hour <= 12;
            var meridiemHour = isAm ? hour : hour - 12;
            return {
                hour: hour,
                meridiemHour: meridiemHour,
                meridiem: isAm ? "AM" : "PM",
                icon: icon,
                name: name
            } as HourHolder;
        });

        this.buildFilterForm();
        this.buildMoveForm();
    }

    setDateHolder = () => {
        this.dateHolder = new DateHolder();
        var tempDate = this.calendar.getToday();
        this.dateHolder.date = tempDate;
        this.dateHolder.fDate = new Date(tempDate.year, tempDate.month - 1, tempDate.day);
    }

    ngOnInit() {
        this.appData.userAccount
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((userAccount: IUserAccount) => {
                if (userAccount) {
                    this.page.userAccount = userAccount;
                    if (this.isNurseMode) {
                        this.route.params
                            .subscribe((params: Params) => {
                                this.encryptId = params["id"];
                                if (1 !== userAccount.roleId || this.encryptId) {
                                    this.id = userAccount.accountId;
                                    this.fetch();
                                } else {
                                    this.showNurses = true;
                                    this.fetchNurses()
                                }
                            });

                    } else {
                        this.route.parent.paramMap
                            .subscribe((params: Params) => {
                                this.id = +(params["params"]["id"] || 0);
                                this.isAdmission = "a" === params["params"]["type"];
                                this.loading = true;


                                this.fetchDates(() => {
                                    this.fetch();
                                })

                                if (this.id) {
                                    this.admissionFetchHelper.admissionFetch(this.id, this.isAdmission, (data: IAdmissionModel) => {
                                        this.admission = data;
                                    });
                                }
                            });
                    }

                } else {
                    this.page.userAccount = undefined;
                }
            });
    }

    ngOnDestroy() {
        clearInterval(this.interval);
    }

    setMarkDetails = () => {
        var now = new Date();
        this.markDetails.hour = now.getHours();
        this.markDetails.left = Math.ceil((100 / 60) * now.getMinutes());
        this.markDetails.time = now;
    }

    private buildFilterForm() {
        var filterTypeControl = new FormControl(FilterType.CurrentAndNext, [Validators.required])
        var nurseId = new FormControl(null)
        var patientId = new FormControl(null)
        this.filterForm = this.formBuilder.group({
            filterType: filterTypeControl,
            nurseId: nurseId,
            patientId: patientId
        });

        nurseId.valueChanges.subscribe(id => {
            this.id = id;
            this.patients = new Array<IResource>();
            this.fetch();
        })

        patientId.valueChanges.subscribe(fullName => {
            this.patientFilterHelper(fullName);
        })
    }

    get moveFormControls() {
        return this.moveForm.controls
    }

    private buildMoveForm() {
        this.moveForm = this.formBuilder.group({
            time: [null, [Validators.required]],
            reason: [null, [Validators.required]]
        });
    }

    patientFilterHelper = (fullName: string) => {
        this.records = fullName ? LinqHelper.cloneDeepArray(this.cloneRecords.map(x => {
            var obj = { ...x };
            obj.medications = LinqHelper.cloneDeepArray(x.medications.filter(y => y.fullName === fullName));
            obj.labs = LinqHelper.cloneDeepArray(x.labs.filter(y => y.fullName === fullName));
            obj.notes = LinqHelper.cloneDeepArray(x.notes.filter(y => y.fullName === fullName));
            return obj;
        })) : LinqHelper.cloneDeepArray(this.cloneRecords);
    }

    // MODEL
    modelOpenHelper = (content: TemplateRef<any>) => {
        this.modalRef = this.modalService.open(content, {
            backdrop: "static",
            keyboard: false,
            centered: false,
            size: "lg",
            windowClass: "custom-modal effect-scale"
        });
    }

    onCloseModal() {
        try {
            this.modalRef.close();
            this.modalRef = undefined;

            this.moveReset();

        } catch (e) {
            // ignored;
        }
    }

    moveReset = () => {
        
        if (this.movingIndex !== -1 && this.movingObjectIndex !== -1 && this.movingObject) {
            this.records[0].medications[this.movingIndex].timeSlots[this.movingObjectIndex] = LinqHelper.cloneDeep<TimeSlotHelper>(this.movingObject);
            this.movingIndex = -1;
            this.movingObjectIndex = -1;
            this.movingObject = null;
        }
    }

    takeQuickMedicine = (item: ProgressReportMedication, id: number, slot: TimeSlotHelper = null) => {
        // if (!this.admission.isDischarged) {
        if (true) {

            if (slot && (slot.isTaking || slot.status)) return;
            if (item.isMedicineTaking) return;

            if (slot) slot.isTaking = true;
            item.isMedicineTaking = true;
            var today = new Date();
            this.dates.current = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
            const obj = {
                id: item.progressReportMedicationId,
                by: this.page.userAccount.accountId,
                admissionId: this.isNurseMode ? item.admissionId : this.id,
                createdBy: this.page.userAccount.fullName,
                medicationDate: { year: this.dates.current.getFullYear(), month: this.dates.current.getMonth() + 1, day: this.dates.current.getDate() },
                instructionIds: [id]
            }

            this.httpService
                .post<GenericResponse>(ApiResources.getURI(ApiResources.progressReport.base, ApiResources.progressReport.takeMedication), [obj])
                .subscribe(
                    (response: GenericResponse) => {
                        if (GenericStatus[GenericStatus.Success] === response.status) {
                            item.isMedicineTaking = false;
                            if (slot) {
                                slot.isTaking = false;
                                slot.status = true;
                                slot.when = null;
                            }

                            item.status = true;
                            item.when = null;
                        } else {
                            this.notifyService.warning(response.message);
                        }
                    },
                    () => {
                        this.notifyService.defaultError();
                    }
                );
        }
    }

    private fetchNurses = () => {
        this.loading = true;
        this.resourceService.fetchNurses()
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: Array<IResource>) => {
                this.nurses = response;
            });
    }

    fetchDates = (callback?: Function) => {
        this.loading = true;
        this.contentLoading = true;
        this.httpService
            .post<GenericResponse>(ApiResources.getURI(ApiResources.progressReport.base, ApiResources.progressReport.fetchTimelineDates),
                { admissionId: this.id, date: this.dates.current })
            .subscribe(
                (response: GenericResponse) => {
                    if (GenericStatus[GenericStatus.Success] === response.status) {
                        var data = response.data as DatesViewModel;
                        const dates = data.dates;
                        this.allDates = data.allDates;

                        this.dates.min = new Date(dates.min || new Date());
                        this.dates.max = new Date(dates.max || new Date());

                        var today = new Date();
                        this.dates.current = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
                        if (this.isMaxGtThanToday()) {
                            this.dates.current = new Date(this.dates.max);
                        }

                        this.dates.currentIndex = this.allDates.findIndex(x => this.dates.current.getTime() === new Date(x).getTime());
                        if (-1 === this.dates.currentIndex) {
                            this.dates.currentIndex = this.allDates.length - 1;
                        }

                        this.dates.current = this.allDates[this.dates.currentIndex];

                        callback();
                    }
                },
                () => {
                    this.notifyService.defaultError();
                    callback();
                }
            );

    }

    changeViewType = (type: ViewType) => {
        this.currentViewType = type;
        if(type !== ViewType.Patients) {
            this.contentLoading = true;
            setTimeout(() => {
                this.fetch();
            });
        }
    }

    matchedItem = (hour: number, i: number) => {
        return this.records[0].medications.length && this.records[0].medications[i].timeSlots && this.records[0].medications[i].timeSlots.find(x => x.hour >= hour && x.hour <= hour)
    }

    matchedIndex = (hour: number, i: number) => {
        var timeSlots = this.records[0].medications.length && this.records[0].medications[i].timeSlots;
        return !timeSlots ? -1 : this.records[0].medications[i].timeSlots.findIndex(x => x.hour >= hour && x.hour <= hour);
    }

    onMouseDown = (i: number, j: number) => {
        var timeSlots = this.records[0].medications[i].timeSlots;
        var found = timeSlots && j !== -1 && timeSlots[j];
        if (found) {
            found.barWidth += 5;
            found.interval = setInterval(() => {
                found.showBar = true;
                setTimeout(() => {
                    found.barWidth += 7;
                    if (found.barWidth > 100) {
                        found.barWidth = 0;
                        found.showBar = false;
                        clearInterval(found.interval);
                        this.onMove(i, j);
                    }
                });
            }, 100);
        }
    }

    onMouseUp = (i: number, j: number) => {
        var timeSlots = this.records[0].medications[i].timeSlots;
        var found = timeSlots && j !== -1 && timeSlots[j];
        if (found) {
            found.barWidth = 0;
            found.showBar = false;
            clearInterval(found.interval);
        }
    }

    fetchMoves = (i: number, j: number, content: TemplateRef<any>) => {
        var timeSlots = this.records[0].medications[i].timeSlots;
        var found = timeSlots && j !== -1 && timeSlots[j];

        if (found && found.hasMoveLoading) return;

        if (found) {
            this.moves = new Array<IMoveModel>();
            found.hasMoveLoading = true;
            var data = {
                value: found.progressReportMedicationFrequencyId
            }

            this.httpService
                .post<GenericResponse>(ApiResources.getURI(ApiResources.nurseShift.base, ApiResources.nurseShift.fetchMoves), data)
                .pipe(finalize(() => this.moveSubmitting = false))
                .subscribe(
                    (response: GenericResponse) => {
                        if (GenericStatus[GenericStatus.Success] === response.status) {
                            var moves = response.data as Array<IMoveModel>;
                            moves.forEach(x => {
                                x.time = new Date(0, 0, 0, x.hour, x.minute, 0);
                            });
                            this.moves = moves;
                            found.hasMoveLoading = false;
                            setTimeout(() => {
                                this.modelOpenHelper(content);
                            });
                        } else {
                            this.notifyService.defaultError(response.message);
                        }
                    },
                    () => {
                        found.hasMoveLoading = false;
                        this.notifyService.defaultError();
                    }
                );
        }
    }

    onMove = (i: number, j: number) => {
        this.movingIndex = i;
        this.movingObjectIndex = j;
    }

    onMoveComplete = (item: HourHolder, content: TemplateRef<any>) => {
        if (this.movingIndex !== -1 && this.movingObjectIndex !== -1) {
            var found = this.records[0].medications[this.movingIndex].timeSlots[this.movingObjectIndex];
            this.movingObject = LinqHelper.cloneDeep<TimeSlotHelper>(found);
            found.hour = item.hour;
            found.meridiemHour = item.hour > 12 ? item.hour - 12 : item.hour;
            found.minute = "0".toString().padEnd(2, "0");
            found.isTaking = true;

            this.moveForm.patchValue({
                time: this.datePipe.transform(new Date(0, 0, 0, item.hour, 0), 'HH:mm'),
            })

            this.modelOpenHelper(content);
        }
    }

    onMoveSubmit = () => {
        this.moveSubmitted = true;
        if (this.moveForm.invalid || this.moveSubmitting) return;
        this.moveSubmitting = true;

        var found = this.records[0].medications[this.movingIndex].timeSlots[this.movingObjectIndex];
        var data = {
            progressReportMedicationFrequencyId: found.progressReportMedicationFrequencyId,
            time: this.moveForm.value.time,
            reason: this.moveForm.value.reason,
            createdBy: this.page.userAccount.accountId
        }

        this.httpService
            .post<GenericResponse>(ApiResources.getURI(ApiResources.nurseShift.base, ApiResources.nurseShift.move), data)
            .pipe(finalize(() => this.moveSubmitting = false))
            .subscribe(
                (response: GenericResponse) => {
                    if (GenericStatus[GenericStatus.Success] === response.status) {
                        found.isTaking = false;
                        found.hasMove = true;
                        found.minute = this.moveForm.value.time.split(":")[1].padEnd(2, "0");
                        this.moveSubmitted = false;
                        this.movingIndex = -1;
                        this.movingObjectIndex = -1;
                        this.movingObject = null;
                        this.moveForm.reset();
                        this.onCloseModal();
                    } else {
                        this.notifyService.defaultError(response.message);
                        this.moveReset();
                    }
                },
                () => {
                    this.notifyService.defaultError();
                    this.moveReset();
                }
            );
    }

    getActionDetails = (hour: number, i: number) => {
        var item = this.records[0].medications[i];
        return item.breakfastModel.hour === hour
            ? { short: "B-FAST", long: "Breakfast" }
            : item.lunchModel.hour === hour
                ? { short: "LUNCH", long: "Lunch" }
                : item.dinnerModel.hour === hour
                    ? { short: "DINNER", long: "Dinner" } : null;
    }

    fetch = () => {
        this.contentLoading = true;
        this.setHeight = false;
        setTimeout(() => {
            var subUrl = ViewType.Grid === this.currentViewType || ViewType.Time === this.currentViewType
                ? ApiResources.progressReport.fetchTimeline
                : ApiResources.progressReport.fetchAllTimeline;

            var data = !this.isNurseMode
                ? { admissionId: this.id, date: this.allDates[this.dates.currentIndex] }
                : { value: this.id, id: this.encryptId, dateModel: this.dateHolder.date, isNurse: true };

            this.httpService
                .post<GenericResponse>(ApiResources.getURI(ApiResources.progressReport.base, subUrl), data)
                .pipe(finalize(() => { this.loading = false; this.contentLoading = false; }))
                .subscribe(
                    (response: GenericResponse) => {
                        if (GenericStatus[GenericStatus.Success] === response.status) {
                            const data = response.data as Array<GlobalAllViewModel<ProgressReportMedication, Lab>>;

                            if (!this.isNurseMode) {
                                this.checkMin();
                                this.checkMax();
                            }

                            if (this.patients.length <= 0) {
                                this.patients = (Array.prototype.concat.apply([], data.map(x => [
                                    ...x.medications.map(y => ({ value: y.fullName })),
                                    ...x.labs.map(y => ({ value: y.fullName })),
                                    ...x.notes.map(y => ({ value: y.fullName }))])) as Array<IResource>)
                                    .filter((x, i, s) => LinqHelper.uniqueOnlyByAlt(x, i, s, "value"))
                            }

                            var tempMedications = [], tempLabs = [], tempNotes = [];
                            data.forEach(x => {
                                tempMedications.push(...x.medications);
                                tempLabs.push(...x.labs);
                                tempNotes.push(...x.notes);
                            });
                            this.productWidth = (Math.max(...tempMedications.map(x => x.productName.length), ...tempLabs.map(x => x.testName.length)) * PIXEL_PER_LETTER) + BUFFER_WIDTH;
                            this.userWidth = (Math.max(...tempMedications.map(x => x.fullName.length), ...tempLabs.map(x => x.fullName.length), ...tempNotes.map(x => x.fullName.length)) * PIXEL_PER_LETTER) + (ViewType.Time === this.currentViewType ? TIME_USER_BUFFER_WIDTH : USER_BUFFER_WIDTH);

                            if (ViewType.Time === this.currentViewType && data && data.length > 0) {
                                var array = new Array<ProgressReportMedication>();
                                var admissionIds = data[0].medications.map(x => x.admissionId).filter(LinqHelper.uniqueOnly);
                                admissionIds.forEach(x => {
                                    var admissions = data[0].medications.filter(y => y.admissionId === x);
                                    var productIds = admissions.map(y => y.pharmacyProductId).filter(LinqHelper.uniqueOnly);
                                    productIds.forEach(y => {
                                        var products = admissions.filter(z => z.pharmacyProductId === y);
                                        var content = { ...products[0] };
                                        content.timeSlots = products.filter(z => !!z.timeSlot).map(z => ({
                                            hour: z.timeSlot.hour,
                                            isTaking: false,
                                            meridiemHour: z.timeSlot.hour > 12 ? z.timeSlot.hour - 12 : z.timeSlot.hour,
                                            minute: z.timeSlot.minute.toString().padEnd(2, "0"),
                                            name: z.medicationInstructionName,
                                            status: z.status,
                                            hasMove: z.hasMove,
                                            when: z.when,
                                            barWidth: 0,
                                            showBar: false,
                                            hasMoveLoading: false,
                                            progressReportMedicationFrequencyId: z.progressReportMedicationFrequencyId,
                                            activeStatus: z.activeStatus,
                                        } as TimeSlotHelper)) || [];
                                        array.push(content)
                                    })
                                })
                                data[0].medications = array;
                            }

                            this.cloneRecords = data;
                            this.patientFilterHelper(this.filterForm.get("patientId").value);
                        }

                        this.previousLoading = false;
                        this.nextLoading = false;

                        ViewType.Time === this.currentViewType && setTimeout(() => {
                            var index = this.hours.findIndex(x => x.hour === new Date().getHours());
                            index !== -1 && document.getElementById('header_' + (index <= 18 ? (index + 5) : index)).scrollIntoView();
                            this.setHeight = true;
                        }, 200);
                    },
                    () => {
                        this.notifyService.defaultError();
                    }
                );
        });
    }

    // Concept Methods
    onPrevious = () => {
        if (!this.isNurseMode) {
            if (!this.dates.showMin) return;
            --this.dates.currentIndex;
            this.dates.current = new Date(this.allDates[this.dates.currentIndex]);
        } else {
            var tempDate = this.calendar.getPrev(this.dateHolder.date);
            this.dateHolder.date = tempDate;
            this.dateHolder.fDate = new Date(tempDate.year, tempDate.month - 1, tempDate.day);
        }

        this.patients = new Array<IResource>();
        this.previousLoading = true;
        this.fetch();
    }

    checkMin = () => {
        this.dates.showMin = !!this.allDates[this.dates.currentIndex - 1];
    }

    onNext = () => {
        if (!this.isNurseMode) {
            if (!this.dates.showMax) return;
            ++this.dates.currentIndex;
            this.dates.current = new Date(this.allDates[this.dates.currentIndex]);
        } else {
            var tempDate = this.calendar.getNext(this.dateHolder.date);
            this.dateHolder.date = tempDate;
            this.dateHolder.fDate = new Date(tempDate.year, tempDate.month - 1, tempDate.day);
        }

        this.patients = new Array<IResource>();
        this.nextLoading = true;
        this.fetch();
    }

    checkMax = () => {
        this.dates.showMax = !!this.allDates[this.dates.currentIndex + 1]
    }

    isGreaterDate = (date: Date, today: Date) => {
        return date.getFullYear() > today.getFullYear() ||
            (date.getMonth() > today.getMonth() &&
                date.getFullYear() === today.getFullYear()) ||
            (date.getDate() > today.getDate() &&
                date.getMonth() === today.getMonth() &&
                date.getFullYear() === today.getFullYear());
    }

    isMaxGtThanToday = () => {
        var now = new Date();
        var max = this.dates.max;
        return now.getFullYear() > max.getFullYear() ||
            (now.getMonth() > max.getMonth() &&
                now.getFullYear() === max.getFullYear()) ||
            (now.getDate() > max.getDate() &&
                now.getMonth() === max.getMonth() &&
                now.getFullYear() === max.getFullYear());
    }

    onBack = () => {
        this.locationService.back();
    }

    @HostListener('document:mousedown', ['$event'])
    onGlobalClick(event): void {
        if (this.movingIndex !== -1 && this.movingObjectIndex !== -1 && !this.movingObject && !(event.target.classList as DOMTokenList).contains("available-slot")) {
            this.movingIndex = -1;
            this.movingObjectIndex = -1;
        }
    }
}
